import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { type InferResponse, fetchClient } from '../../typedClient'

// Hook to fetch current user data from /meta/user/me endpoint
type MeResponse = InferResponse<'/meta/user/me', 'post'>

// Hook to fetch current user data from /meta/user/me endpoint
export const useUser = (options?: UseQueryOptions<MeResponse, Error>) => {
  return useQuery<MeResponse, Error>({
    queryKey: ['user', 'me'],
    queryFn: async () => {
      const { data, error } = await fetchClient.POST('/meta/user/me')
      if (error || !data) {
        throw new Error(`Failed to fetch user: ${JSON.stringify(error)}`)
      }
      return data
    },
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes (formerly cacheTime)
    ...options,
  })
}
